import APIService from "./APIService";
import DebugService from "./DebugService";

/**
 * @description User Management API Service
 */
const UserManagementApiService = {
  /**
   * List all users
   */
  listUsers: async () => {
    try {
      return await APIService.get("user-management/list-users");
    } catch (error) {
      DebugService.error("UserManagement API: Error listing users", error);
      throw error;
    }
  },

  /**
   * Create a new user
   * @param {Object} payload
   * @param {string} payload.username
   * @param {string} payload.email
   * @param {string} payload.role
   */
  createUser: async (payload) => {
    try {
      return await APIService.post("auth/create-user", payload);
    } catch (error) {
      DebugService.error("UserManagement API: Error creating user", error, payload);
      throw error;
    }
  },

  /**
   * Update a user's role
   * @param {Object} payload
   * @param {string} payload.username
   * @param {string} payload.oldRole
   * @param {string} payload.newRole
   */
  updateRole: async (payload) => {
    try {
      return await APIService.post("user-management/update-role", payload);
    } catch (error) {
      DebugService.error("UserManagement API: Error updating role", error, payload);
      throw error;
    }
  },

  /**
   * Delete a user
   * @param {string} username
   */
  deleteUser: async (username) => {
    try {
      return await APIService.delete("user-management/delete-user", {
        data: { username },
      });
    } catch (error) {
      DebugService.error("UserManagement API: Error deleting user", error, username);
      throw error;
    }
  },

  /**
   * Disable a user
   * @param {string} username
   */
  disableUser: async (username) => {
    try {
      return await APIService.post("user-management/disable-user", { username });
    } catch (error) {
      DebugService.error("UserManagement API: Error disabling user", error, username);
      throw error;
    }
  },

  /**
   * Enable a user
   * @param {string} username
   */
  enableUser: async (username) => {
    try {
      return await APIService.post("user-management/enable-user", { username });
    } catch (error) {
      DebugService.error("UserManagement API: Error enabling user", error, username);
      throw error;
    }
  },
};

export default UserManagementApiService;